export default {
    byTheme(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('themeId', id).get()
            )
        )
    }
}
